import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.replace";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _debounce from "lodash/debounce";
import _delay from "lodash/delay";
import { mapGetters } from 'vuex';
import searchSuggestionQuery from '~/graphql/searchSuggestion.gql';
import { TIMER } from '~/const/timers';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/loupe.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/micro.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/cross.svg';

const SearchResults = () => import('./SearchResults.vue');

const LayerFullscreen = () => import(
/* webpackChunkName: "layer" */
'~/components/specific/MainHeader/LayerFullscreen.vue');

const AlgoliaSearch = () => import('~/components/organisms/Category/AlgoliaSearch.vue');

export default {
  name: 'SearchItem',
  components: {
    SearchResults,
    LayerFullscreen
  },

  data() {
    return {
      algoliaSearchComponent: null,
      algoliaSearch: null,
      isOpenMenu: false,
      searchError: false,
      search: '',
      results: {
        products: [],
        total: 0
      },
      loading: false
    };
  },

  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    formAction() {
      return "/".concat(this.locale.market, "/").concat(this.locale.language, "/q/").concat(this.sanitizedSearch);
    },

    sanitizedSearch() {
      return this.search.trim().replace(/[()<>[\]{}"/\\;=?.]/gi, '');
    }

  }),
  watch: {
    search() {
      this.debounceGetSuggestion();
    },

    value() {
      if (this.type === 'search' && this.value === true && this.$refs.search !== undefined) {
        this.focus();
      }

      if (this.type === 'search' && !this.value) {
        this.resetForm();
      }
    }

  },

  mounted() {
    this.$root.$on('open-algolia-search', () => {
      this.openSearch();
    });
    this.$root.$on('close-algolia-search', () => {
      this.closeSearch(true);
    });
  },

  methods: {
    openSearch() {
      this.algoliaSearch = this.$cookies.get('algolia') && this.locale.iso === 'fr-FR';
      let tracking = {
        data: {
          event_category: 'Header',
          event_action: 'Search',
          event_label: 'ES_Clic'
        }
      };

      if (this.algoliaSearch) {
        this.isOpenMenu = true;
        this.algoliaSearchComponent = AlgoliaSearch;
        tracking = {
          data: {
            event_category: 'Header',
            event_action: 'Search',
            event_label: 'Algolia_Clic'
          }
        };
      }

      this.$root.$emit('generic-tracking', null, tracking);
    },

    closeSearch() {
      let productClicked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.isOpenMenu = false;
      this.algoliaSearchComponent = null;

      if (!productClicked) {
        this.$root.$emit('generic-tracking', null, {
          data: {
            event_category: 'Header',
            event_action: 'Search',
            event_label: 'Algolia_Fermer'
          }
        });
      }
    },

    debounceGetSuggestion: _debounce(function getSuggestions() {
      this.getSuggestions();
    }, 200),

    focusSearchInput() {
      _delay(() => this.$refs.search.focus(), 50);
    },

    handleSubmit() {
      if (this.search === '') {
        this.searchError = true;

        _delay(() => {
          this.searchError = false;
        }, TIMER);
      }

      this.$router.push(this.formAction);
      this.resetForm();
      this.$refs.search.blur();
      this.$emit('submitCloseMenu');
      this.$root.$emit('generic-tracking', null, {
        data: {
          event_category: 'Header',
          event_action: 'Search',
          event_label: 'ES_Entrée'
        }
      });
    },

    handleInput(_ref) {
      let {
        target
      } = _ref;
      this.search = target.value;
    },

    handleArrowUp() {
      this.$refs.searchResults.focusLastItem();
    },

    handleArrowDown() {
      this.$refs.searchResults.focusFirstItem();
    },

    handleLeaveViewSuggestion() {
      this.resetForm();
      this.$root.$emit('hide-layer');
    },

    gotToSearch() {
      this.$root.$emit('hide-layer');
      this.$router.push(this.formAction);
      this.resetForm();
    },

    getSuggestions() {
      var _this = this;

      return _asyncToGenerator(function* () {
        if (!_this.sanitizedSearch) {
          _this.resetForm();

          return;
        }

        if (_this.sanitizedSearch.length < 3) {
          return;
        }

        _this.loading = true;

        try {
          const {
            data: {
              categorySearch,
              productSearchSuggest
            }
          } = yield _this.$apolloProvider.defaultClient.query({
            query: searchSuggestionQuery,
            variables: {
              locale: _this.locale.iso,
              keyword: _this.sanitizedSearch,
              offset: 0,
              limit: 5,
              sortBy: 'POPULAR',
              orderBy: 'DEFAULT',
              filterBy: []
            }
          });
          _this.loading = false;
          const {
            products,
            total: totalProducts
          } = productSearchSuggest;
          const categories = categorySearch;
          const total = products.length + categories.length;
          _this.results = {
            query: _this.sanitizedSearch,
            products,
            categories,
            total,
            totalProducts
          };
        } catch (_unused) {
          _this.loading = false;
        }
      })();
    },

    resetForm() {
      this.search = '';
      this.searchError = false;
      this.results = {
        products: [],
        total: 0
      };
    }

  }
};